import { render, staticRenderFns } from "./TolusImmo.vue?vue&type=template&id=177677a8&scoped=true&"
import script from "./TolusImmo.vue?vue&type=script&lang=js&"
export * from "./TolusImmo.vue?vue&type=script&lang=js&"
import style0 from "./TolusImmo.vue?vue&type=style&index=0&id=177677a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177677a8",
  null
  
)

export default component.exports